import { NavCard, NavCardSkeleton } from '../../../components/common/NavCard';
import { PageContainer } from '../../../components/layout/page/PageContainer';
import { PageContainerTitle } from '../../../components/layout/page/PageContainerTitle';
import { useCourseFinderLinks } from '../../../hooks/useCourseFinderLinks';

/** 코스 찾기 페이지 */
const FindCourse = () => {
  const { links, loading } = useCourseFinderLinks();

  return (
    <PageContainer>
      <PageContainerTitle
        title="코스 찾기"
        description="어떤 코스를 찾고 계신가요?"
      />

      {/* 코스 찾기 링크 카드 목록 */}
      <div className="my-5 grid grid-cols-1 gap-4 px-[20px] lg:mt-9 lg:grid-cols-3 xl:px-0">
        {loading
          ? Array.from({ length: 3 }, (_, i) => <NavCardSkeleton key={i} />)
          : links.map((item) => (
              <NavCard
                key={item.id}
                to={item.linkUrl}
                imageSrc={item.iconImageUrl ?? undefined}
                topText={item.description ?? undefined}
                bottomText={item.name}
                // 내부 경로(/courses/...)는 같은 탭, 외부 URL만 새 탭
                // blank={/^https?:\/\//.test(item.linkUrl)}
                blank={false}
              />
            ))}
      </div>
    </PageContainer>
  );
};

export default FindCourse;
